import React, { useEffect, useMemo, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material'
import { getDateForInputFieldFromTimestamp } from '../../utils/date'

const EventModal = ({ isOpen, event, onClose, onSave, eventTypes }) => {
  const EMPTY_EVENT = {
    name: '',
    date: new Date().toLocaleDateString('sv'),
    description: '',
    eventType: eventTypes?.[0],
  }

  const [localCopy, setLocalCopy] = useState(EMPTY_EVENT)

  useEffect(() => {
    setLocalCopy(
      event
        ? { ...event, date: getDateForInputFieldFromTimestamp(event.date) }
        : EMPTY_EVENT
    )
  }, [event])

  const handleClose = () => {
    onClose()
  }

  const updateLocalCopy = (key, value) =>
    setLocalCopy((prev) => ({ ...prev, [key]: value }))

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Create an event</DialogTitle>

      <DialogContent>
        <TextField
          label={'Event Name'}
          fullWidth
          margin={'dense'}
          value={localCopy.name || ''}
          onChange={(e) => updateLocalCopy('name', e.target.value)}
        />
        <TextField
          label={'Event Type'}
          fullWidth
          margin={'dense'}
          value={localCopy.typeId || ''}
          onChange={(e) => updateLocalCopy('typeId', e.target.value)}
          select
        >
          {eventTypes.map((et) => (
            <MenuItem key={et.id} value={et.id}>
              {et.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label={'Date'}
          type={'date'}
          margin='dense'
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          value={localCopy.date}
          onChange={(e) => {
            updateLocalCopy('date', e.target.value)
          }}
        />
        <TextField
          label={'Description'}
          onChange={(e) => updateLocalCopy('description', e.target.value)}
          margin='dense'
          fullWidth
          multiline
          rows={4}
          value={localCopy.description || ''}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant={'contained'} onClick={() => onSave(localCopy)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EventModal
